// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.JobRoles = {
  jobRolesHash: null,
  error: null,
  jobRolesFetched: false,
};
